import { createFileRoute } from "@tanstack/react-router";
import IntegrationView from "@/components/views/IntegrationView";

export const Route = createFileRoute("/integration")({
  component: IntegrationView,
});
